import React, { Fragment } from 'react';

import { SchoolAdmin } from '../../models/Admin';
import useModalRef from '../../hooks/useModalRef';
import SchoolAdminListItem from './SchoolAdminListItem';
import NavigationBar from '../../components/NavigationBar';
import SectionHeader from '../../components/SectionHeader';
import { ContentWithFooter } from '../../components/Footer';
import GenericDivider from '../../components/GenericDivider';
import SearchableList from '../../components/SearchableList';
import useSchoolsAdmins from '../../services/swr/useSchoolAdmins';
import AddAdminSchoolModal from './AddAdminSchoolModal';

const SchoolAdminsManagementPage = () => {
  const { schoolAdmins } = useSchoolsAdmins();
  const addSchoolAdminRef = useModalRef();

  const handleSearch = (search: string, admin: SchoolAdmin) => {
    const treatedTeacherName = admin.name?.toLowerCase();

    const match =
      (treatedTeacherName && treatedTeacherName.includes(search)) ||
      admin.email.includes(search);

    return match;
  };

  return (
    <>
      <NavigationBar />
      <ContentWithFooter className="mt-12">
        <SectionHeader className="mb-8">
          <h1 className="text-3xl">
            Gerenciamento dos Administradores de Escola
          </h1>
        </SectionHeader>

        <SearchableList
          dataArray={schoolAdmins}
          searchMatches={handleSearch}
          onAdd={() => addSchoolAdminRef.current?.openModal()}
        >
          {({ data }) => (
            <ul className="space-y-4">
              {data.map((schoolAdmin, index) => (
                <Fragment key={`${schoolAdmin.id}-${schoolAdmin.email}`}>
                  <SchoolAdminListItem adminInfo={schoolAdmin} />
                  {index < schoolAdmins.length - 1 && <GenericDivider />}
                </Fragment>
              ))}
            </ul>
          )}
        </SearchableList>

        <AddAdminSchoolModal ref={addSchoolAdminRef} />
      </ContentWithFooter>
    </>
  );
};

export default SchoolAdminsManagementPage;
